import { ITableField } from '@/shared/Tables/Table'
import { IParameter } from '../../parameters.types'
import ParameterGroupBreadcrumbsPath from '../ParameterGroupBreadcrumbsPath'
import ParameterUnitSpan from '../ParameterUnitSpan'

const parametersTableFields: ITableField<IParameter, keyof IParameter>[] = [
  {
    key: 'name',
    clientSideOrdering: true,
    width: '498px',
    header: 'Наименование',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
  {
    key: 'sourceId',
    clientSideOrdering: true,
    width: '140px',
    header: 'ID',
    getter: (it) => it.sourceId,
    sortGetter: (it) => it.sourceId,
  },
  {
    key: 'dataType',
    clientSideOrdering: true,
    width: '140px',
    header: 'Тип данных',
    getter: (it) => it.dataType.charAt(0).toUpperCase() + it.dataType.slice(1).toLowerCase(),
    sortGetter: (it) => it.dataType,
  },
  {
    key: 'unitId',
    clientSideOrdering: true,
    width: '180px',
    header: 'Единица измерения',
    getter: (it) => <ParameterUnitSpan unitId={it.unitId} />,
    sortGetter: (it) => it.unitId,
  },
  {
    key: 'groupId',
    clientSideOrdering: true,
    width: '498px',
    header: 'Расположение',
    getter: (it) => <ParameterGroupBreadcrumbsPath groupId={it.groupId} />,
    sortGetter: (it) => it.groupId,
  },
]

export default parametersTableFields
